import {ILayoutColumn, ILayoutRow} from '../_interface/layout';
import {IEditableTemplateFields} from '../_interface/editable-template-fields';
import {TLayoutColumnSize} from '../_interface/layout-column-size';
import {MAX_COLUMNS_IN_LAYOUT} from 'shared/magic';
import { times } from 'lodash-es';

const max = MAX_COLUMNS_IN_LAYOUT;
export const fillLayout = (rows: ILayoutRow[], fields: IEditableTemplateFields): ILayoutRow[] =>
	rows.map(row => {
		const s = sumRow(row.map(({size}) => size));
		return s !== max ? restoreRow(row, fields) : row;
	});


export const restoreRow = (row: ILayoutRow, fields: IEditableTemplateFields): ILayoutRow => {
	const minSizeDelta = minSizeDeltaForRow(row, max, fields);
	const minSizeFields = minSizeFieldsInRow(row, fields);
	const safeSizes = minSizeFields.map(v => v + (Math.floor(minSizeDelta / minSizeFields.length)));
	const safeRow = row.map((field, i) => ({...field, size: safeSizes[i] as TLayoutColumnSize}));
	const sum = sumRow(safeSizes);
	const rest = max - sum;
	return rest ? distributeRest(safeRow, rest) : safeRow;
};

export const restoreFields = (arr: ILayoutColumn[], fields: IEditableTemplateFields) => arr.reduce((acc, cv) => {
	return {...acc, ...{[cv.templateFieldId]: {...fields[cv.templateFieldId]}}};
}, {});

const sumRow = (row: number[]) => row.reduce((acc, i) => acc + i, 0);

const findMinCol = (arr: ILayoutRow) => arr.reduce((acc, item, index) =>
	acc.lowest?.size < item.size ? acc : ({lowest: item, index}), {lowest: null, index: -1});

const distributeRest = (row: ILayoutRow, count: number): ILayoutRow => {
	const newRow = [...row];
	times(count, () => {
		const {index} = findMinCol(newRow);
		const col = newRow[index];
		newRow[index] = {...col, size: (col.size + 1 as TLayoutColumnSize)};
	});
	return newRow;
};
const minSizeDeltaForRow = (r: ILayoutRow, maxCol: number, fields: IEditableTemplateFields): number =>
	r.reduce((acc: number, item: ILayoutColumn) => acc - minSize(item.templateFieldId, fields), maxCol);

const minSizeFieldsInRow = (row: ILayoutRow, fields: IEditableTemplateFields): number[] =>
	row.map(({templateFieldId}) => minSize(templateFieldId, fields));

const minSize = (id: string, fields: IEditableTemplateFields) => fields[id].field.minSize;
